import { SORT_MAP } from './leaderboardSlice';
import { buildDefaultFilters } from '../../filterDefaults';

// The deck-list query every detail page (user, author, commander) starts from.
export const defaultDetailListQuery = () => ({
    filters: buildDefaultFilters('decks'),
    sortBy: SORT_MAP.POWERLEVEL,
    sortDirection: SORT_MAP.DIRECTION.DESC,
    selectedListIndex: -1,
});

export const resetDetailListQuery = (state) => {
    Object.assign(state, defaultDetailListQuery());
};

// Opening a different entity starts its list from the defaults; the first load
// keeps whatever a shared link's query string put in the slice.
export const isSwitchingEntity = (loadedIds, id) => {
    const loaded = loadedIds.filter(Boolean);
    return loaded.length > 0 && !loaded.includes(id);
};
